import { AuthorizationModel } from "./../../authentication/models/authorization-model";
import { WelcomeListItemModel } from "../../search/models/welcome-list-item";
import { WelcomeListCollection } from "../../search/collections/welcome-list";
import { autoinject, Container } from "aurelia-dependency-injection";
import { backboneModelProperties } from "../../decorators/backbone-properties";
import { AppSettings } from "../../app-settings";
import { AppEvents } from "../../app-events";
import { BaseDocumentModel } from "../../desktop/models/base-document";
import { prop} from "../../decorators/property";
import { ReelItemModel, ReelItemType } from "./reel-item";
import { OverviewReelModel } from "./overview-reel";
import { AppUser } from "../../authentication/app-user";
import { AuthService } from "../../authentication/auth-service";
import { ContainerHelper } from "../../shared/helpers/container-helper";

export class OverviewDocumentReelModel extends OverviewReelModel {

    @prop() public Title = "Recent documents";
    @prop() public Type = "document-reel";
    public Query;
    private applicationUser: AppUser;

    constructor() {
        super();
        this.applicationUser = ContainerHelper.AuthService.AppUser;
        this.setupEvents();
    }

    public loadData() {
        if (this.isPersonalUser()) {
            const key = `my_justis_documents:${this.applicationUser.Email}`;
            const data = window.localStorage.getItem(key);
            if (data) {
                this.parseData(JSON.parse(data));
            }
        }
    }

    private setupEvents() {
        this.listenTo(this.applicationUser, "refresh", this.userChanged);
        this.appEvents.on(AppEvents.DocumentLoaded, (model) => {
            this.documentLoaded(model);
        });
    }

    private documentLoaded(documentModel) {
        const docKey = documentModel.Id;
        let model = this.Items.where({ DocKey: docKey })[0];
        if (!model) {
            model = this.buildItemModel(documentModel);
        } else {
            this.Items.remove(model);
        }
        if (model) {
            this.Items.unshift(model);
            this.Items.reset(this.Items.first(10));
        }
        if (this.isPersonalUser()) {
            this.persistData();
        }
        this.SlideStart = 0;
        this.trigger("updateDisplay");
    }

    private persistData() {
        const key = `my_justis_documents:${this.applicationUser.Email}`;
        window.localStorage.setItem(key, JSON.stringify(this.Items.toJSON()));
    }

    private parseData(data) {
        this.Items.reset();
        data.forEach((doc) => {
            this.Items.add(doc);
        });
        this.trigger("updateDisplay");
    }

    private createPlaceholder() {
        return new ReelItemModel({ItemType: ReelItemType.Placeholder});
    }

    private userChanged() {
        this.clearData();
        if (this.isPersonalUser()) {
            this.loadData();
        }
    }

    private clearData() {
        this.Items.reset();
        this.trigger("updateDisplay");
    }

    private buildItemModel(doc) {
        try {
            const model = new ReelItemModel();
            model.Title = doc.Title;
            model.Year = doc.Year !== 0 ? doc.Year : null;
            model.Court = doc.Court ? doc.Court.Name : "";
            model.Url = doc.Url;
            model.Flag = doc.IconUrl ? `./assets/images/flags/32/${doc.IconUrl}` : "";
            model.DocKey = doc.Id;
            model.DisplayJurisdiction = doc.DisplayJurisdiction;
            model.Categories = doc.get("DisplayCategories");
            model.ItemType = ReelItemType.Document;
            return model;
        } catch (err) {
            return null;
        }
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/my-justis/models/overview-document-reel.ts